export const MODAL_ROOT_ID = '__sizeid-modal-root';
export const MODAL_CONTAINER_CLASS = '__sizeid-modal-container';
